import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "Басты бет",
    },
  },
  {
    path: "/hajis",
    name: "hajis",
    component: () =>
      import(/* webpackChunkName: "hajis" */ "../views/HajisView.vue"),
    meta: {
      title: "Қажылар",
    },
  },
  {
    path: "/hajis/:id",
    name: "haji_item",
    component: () =>
      import(/* webpackChunkName: "haji_item" */ "../views/HajiItemView.vue"),
    meta: {
      title: "Қажы",
    },
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    meta: {
      title: "Біз туралы",
    },
  },
  {
    path: "/category/:slug",
    name: "category_view",
    props: true,
    component: () =>
      import(/* webpackChunkName: "category" */ "../views/CategorySection.vue"),
    meta: {
      title: "Жаңалықтар",
    },
  },
  {
    path: "/media/video",
    name: "video_section",
    component: () =>
      import(
        /* webpackChunkName: "video_section" */ "../views/VideoSection.vue"
      ),
    meta: {
      title: "Бейнероликтер",
    },
  },
  {
    path: "/media/video/:id",
    name: "video_view",
    props: true,
    component: () =>
      import(/* webpackChunkName: "video_view" */ "../views/VideoItemView.vue"),
    meta: {
      title: "Бейнеролик",
    },
  },
  {
    path: "/media/photo",
    name: "photo_section",
    component: () =>
      import(
        /* webpackChunkName: "photo_section" */ "../views/PhotoSection.vue"
      ),
    meta: {
      title: "Фото",
    },
  },
  {
    path: "/media/photo/:id",
    name: "photo_view",
    props: true,
    component: () =>
      import(/* webpackChunkName: "photo_view" */ "../views/PhotoItemView.vue"),
    meta: {
      title: "Фото",
    },
  },
  {
    path: "/media/book",
    name: "book_section",
    component: () =>
      import(/* webpackChunkName: "book_section" */ "../views/BookSection.vue"),
    meta: {
      title: "Кітаптар",
    },
  },
  {
    path: "/media/book/:id",
    props: true,
    name: "book_view",
    component: () =>
      import(/* webpackChunkName: "book_view" */ "../views/BookItemView.vue"),
    meta: {
      title: "Кітап",
    },
  },
  {
    path: "/article/:id",
    props: true,
    name: "article_view",
    component: () =>
      import(/* webpackChunkName: "article" */ "../views/ArticleView.vue"),
    meta: {
      title: "Мақала",
    },
  },
  {
    path: "/tour-operators",
    name: "tour_operators",
    component: () =>
      import(
        /* webpackChunkName: "tour_operators" */ "../views/TourOperators.vue"
      ),
    meta: {
      title: "Туроператорлар",
    },
  },
  {
    path: "/tour-operator/:id",
    name: "tour_operator_item",
    component: () =>
      import(
        /* webpackChunkName: "tour_operator_item" */ "../views/TourOperatorItem.vue"
      ),
    meta: {
      title: "Туроператор",
    },
  },
  {
    path: "/media",
    name: "media",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    meta: {
      title: "Медиа",
    },
  },
  {
    path: "/holy-places",
    name: "holy_places",
    component: () =>
      import(/* webpackChunkName: "holy_places" */ "../views/HolyPlaces.vue"),
    meta: {
      title: "Қасиетті орындар",
    },
  },
  {
    path: "/holy-places/:id",
    name: "holy_place_item",
    component: () =>
      import(
        /* webpackChunkName: "holy_place_item" */ "../views/HolyPlaceItem.vue"
      ),
    meta: {
      title: "Қасиетті орын",
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    // всегда прокручивать страницу вверх при переходе на новый маршрут
    return { top: 0 };
  },
});

// Добавляем глобальный навигационный хук для изменения заголовка
router.afterEach((to) => {
  document.title = to.meta.title
    ? `${to.meta.title} | ${window.location.hostname}`
    : window.location.hostname;
});

export default router;
